import { DateTime } from "luxon";
import { Link } from "react-router";

import { ROUTES } from "@/app/routes";
import type { RecentSale } from "@/features/dashboard/hooks/useDashboard";
import { formatMoney } from "@/lib/format";

export function RecentSales({ sales, currency }: { sales: RecentSale[]; currency: string }) {
  return (
    <section className="rounded-xl border border-border bg-card">
      <div className="flex flex-wrap items-baseline justify-between gap-2 px-4 py-3">
        <h2 className="text-[15px] font-semibold">Dernières ventes</h2>
        <Link to={ROUTES.vending} className="text-sm font-medium underline underline-offset-4">
          Tout voir
        </Link>
      </div>

      {sales.length === 0 ? (
        <p className="px-4 pb-5 text-sm text-muted-foreground">Les ventes encaissées apparaîtront ici.</p>
      ) : (
        <ul className="border-t border-muted">
          {sales.map((sale) => (
            <li
              key={sale.key}
              className="flex items-center justify-between gap-3 border-b border-muted px-4 py-3 last:border-b-0"
            >
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[15px]">{sale.label}</span>
                <span className="text-xs text-muted-foreground tabular-nums">
                  {sale.at ? DateTime.fromISO(sale.at).setLocale("fr").toFormat("d LLL, HH:mm") : "—"}
                  {" · "}
                  {sale.lineCount} article{sale.lineCount > 1 ? "s" : ""}
                </span>
              </span>
              <span className="font-semibold tabular-nums">{formatMoney(sale.total, currency)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
